import * as React from 'react';
import { useCallback } from 'react';
import cn from 'classnames';
import { useTheme } from '../../../theme';
import { useTranslation } from 'react-i18next';
import { Money as MoneyComponent } from '../../../Money';
import { Money } from '../../../types';
import { Switch } from '@shared/ui';
import { ConfirmOptionVariant } from '../../types';
import { useIsMobile } from '../../../utils';

export interface Props {
	price: Money;
	onChange?: React.Dispatch<boolean>;
	className?: string;
	variant: ConfirmOptionVariant;
	isActive: boolean;
	isDisabled?: boolean;
	isOld?: boolean;
	isLoading?: boolean;
}

const SwitchBlock: React.FC<Props> = ({
	price,
	className,
	onChange,
	variant,
	isActive,
	isDisabled,
	isOld,
	isLoading
}) => {
	const { SwitchBlock: css } = useTheme('FareLock');
	const { t } = useTranslation('FareLock');

	const label = variant === 'FareLock' ? t('Lock fare') : t('Ticket refund');

	const isMobile = useIsMobile();

	const isSwitchAside = isOld && !isMobile;
	const isInvertedSwitch = variant === 'FareLock' && isActive && !isOld;

	const onClick = useCallback(() => {
		if (onChange) {
			onChange(!isActive);
		}
	}, [isActive, onChange]);

	const switchElement = (
		<Switch
			classes={{ root: css.switch_root }}
			checked={isActive}
			onChange={onClick}
			disabled={isDisabled}
			inverted={isInvertedSwitch}
			loading={isLoading}
		/>
	);

	return (
		<div
			className={cn(css.root, className, {
				[css.root_old]: isOld,
				[css.root_disabled]: isDisabled,
				[css.root_refund]: variant === 'Refund',
				[css.root_farelock]: variant === 'FareLock'
			})}
		>
			<div className={css.info}>
				<div className={css.actionText}>
					<span>{label}</span>
					{!isSwitchAside && <span>,</span>}

					{isSwitchAside && switchElement}
				</div>

				<div className={css.price_wrapper}>
					<div className={css.price_label}>{t('only')}</div>

					<div className={css.price}>
						<MoneyComponent money={price} />
					</div>
				</div>
			</div>

			{!isSwitchAside && <div className={css.switch_wrapper}>{switchElement}</div>}
		</div>
	);
};

export default SwitchBlock;
